/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { createTrackModelSchema } from "../createTrackModelSchema.ts";
import { guidCreatedOrUpdatedEntityModelSchema } from "../guidCreatedOrUpdatedEntityModelSchema.ts";
import { z } from "zod";

/**
 * @description Идентификатор добавленного трека
 */
export const postApiTracks200Schema = z.lazy(() => guidCreatedOrUpdatedEntityModelSchema)

/**
 * @description Ошибка валидации | Автор не является владельцем альбома
 */
export const postApiTracks400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const postApiTracks401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const postApiTracks403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Автор не найден | Альбом не найден | Жанр не найден
 */
export const postApiTracks404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const postApiTracks500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса
 */
export const postApiTracksMutationRequestSchema = z.lazy(() => createTrackModelSchema).describe("Тело запроса")

export const postApiTracksMutationResponseSchema = z.lazy(() => postApiTracks200Schema)